module.exports = __webpack_public_path__ + "static/img/articles.3f5869f9.png";